export function authHeader() {
  let token = localStorage.getItem("authToken");

  if (token) {
    return { Authorization: "Bearer " + token };
  } else {
    return {};
  }
}
